import { AxiosRequestConfig } from 'axios';
import qs from 'qs';
import instance, { CRM_REPORT_API_URL } from 'api';
import { IPartnerRatingByPartner } from '../../interfaces';

export const getPartnersRatingByPartner = async (config?: AxiosRequestConfig) => {
  return instance(true, CRM_REPORT_API_URL)
    .get<{ list: IPartnerRatingByPartner[]; totalCount: number }>('/partner/rating/listByPartner', {
      ...config,
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }),
    })
    .then((response) => response.data);
};

export const exportPartnersRatingByPartnerExcel = async (config?: AxiosRequestConfig) => {
  return instance(true, CRM_REPORT_API_URL)
    .get<Blob>('/partner/rating/listByPartner/export', {
      ...config,
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }),
      responseType: 'blob',
    })
    .then((response) => response.data);
};

export const exportAllPartnersRatingByPartnerExcel = async (config?: AxiosRequestConfig) => {
  return instance(true, CRM_REPORT_API_URL)
    .get<Blob>('/partner/rating/listByPartner/allServiceTypeExport', {
      ...config,
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true }),
      responseType: 'blob',
    })
    .then((response) => response.data);
};
